import { render, staticRenderFns } from "./VersionMobileView.vue?vue&type=template&id=50a81db0&scoped=true"
import script from "./VersionMobileView.vue?vue&type=script&lang=js"
export * from "./VersionMobileView.vue?vue&type=script&lang=js"
import style0 from "./VersionMobileView.vue?vue&type=style&index=0&id=50a81db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a81db0",
  null
  
)

export default component.exports